// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".activeBtn[data-v-5d6360ca]{color:var(--primary);border-bottom:1px solid var(--primary)}", ""]);
// Exports
module.exports = exports;
